import type { FieldMetadataMessageDescriptorDef } from './types';
import { msg } from '@lingui/core/macro';

export const productCategoryField: FieldMetadataMessageDescriptorDef = {
  displayName: msg({
    message: 'Product category',
    context: 'Name of a column in table of activity data',
  }),
  externalDescription: msg({
    message: 'The type of product',
    context: 'Description of a column in table of activity data',
  }),
};

export const isThirdPartyField: FieldMetadataMessageDescriptorDef = {
  displayName: msg({
    message: 'Is third party',
    context: 'Whether purchased by the company or by a third party.',
  }),
  externalDescription: msg({
    message: 'Whether purchased by the company or by a third party.',
    context: 'Is third party',
  }),
};

export const productFields = {
  product: {
    displayName: msg({
      message: 'Sold product name',
      context: 'The display name for the sold product name field',
    }),
  },
  product_id: {
    displayName: msg({
      message: 'Sold product ID',
      context: 'The display name for the sold product ID field',
    }),
  },
} as const satisfies Record<string, FieldMetadataMessageDescriptorDef>;

export const purchasedMaterialFields = {
  purchased_material_id: {
    displayName: msg({
      message: 'Purchased material ID',
      context: 'The display name for the purchased material ID field',
    }),
  },
  purchased_material_name: {
    displayName: msg({
      message: 'Purchased material name',
      context: 'The display name for the purchased material name field',
    }),
  },
} as const satisfies Record<string, FieldMetadataMessageDescriptorDef>;
